(function () {
  'use strict';

  /* ── BOT DOMAIN BLOCKLIST ───────────────────────────────── */
  var BLOCKED = [
    'meta1.in.net', 'pifpaf.space', 'ge-credit.store', 'ge-credit.ru',
    'xrust.club', 'zlot555.com', 'imails.site', 'softdisc.site',
    'vmailer.site', 'cocaine-in-kyiv.online', 'tupop.online',
    'mymailer.buzz', 'filmkachat.ru', 'vykup-auto123.ru', 'adann.xyz',
    'webstor-globalyou.store', 'ui.dogle.info'
  ];
  function isBlocked(email) {
    var parts = email.split('@');
    if (parts.length !== 2) return false;
    var domain = parts[1].toLowerCase();
    for (var i = 0; i < BLOCKED.length; i++) {
      if (domain === BLOCKED[i] || domain.slice(-(BLOCKED[i].length + 1)) === '.' + BLOCKED[i]) return true;
    }
    return false;
  }

  /* ── CONFIG ─────────────────────────────────────────────── */
  var COMPANY_ID   = 'Y9Wa3b';
  var LIST_ID      = 'XmEwJL';
  var CODE         = 'WELCOME10';
  var KEY_DONE     = 'pw_quiz_v1_done';
  var KEY_SEEN     = 'pw_quiz_v1_seen';
  var TRIGGER_MS   = 6000;    // show after 6s on page
  var TRIGGER_PGS  = 2;       // OR after 2 pages in session
  var RESURFACE_MS = 7 * 24 * 60 * 60 * 1000; // re-show after 7 days if dismissed

  /* ── GATES ───────────────────────────────────────────────── */
  if (localStorage.getItem(KEY_DONE)) return;
  var seenAt = localStorage.getItem(KEY_SEEN);
  if (seenAt && Date.now() - parseInt(seenAt) < RESURFACE_MS) return;

  /* ── PAGE-TYPE SUPPRESSION ──────────────────────────────────
     Don't interrupt shoppers who are mid-purchase. Runs on home,
     blog and collection pages; skipped on product/cart/checkout. */
  var path = location.pathname;
  if (/\/products\//.test(path) || /^\/cart/.test(path) || /\/checkouts?(\/|$)/.test(path)) return;
  /* Account/self-service pages (Awtomic subscription portal lives at
     /tools/bundle-subscriptions). A member arriving from a win-back or
     card-update email needs the login field, not a quiz over the top of it. */
  if (/^\/tools\//.test(path) || /^\/account/.test(path) || /^\/apps\/club/.test(path)) return;   // Wine Club page, 2026-09-18

  /* ── PAGE COUNT ─────────────────────────────────────────── */
  var PG_KEY  = 'pw_pgs_v1';
  var pgCount = parseInt(sessionStorage.getItem(PG_KEY) || '0') + 1;
  sessionStorage.setItem(PG_KEY, pgCount);


  /* -- EMAIL TYPO GUARD ------------------------------------
     The validity regex accepts ANY tld, so real people typing ".con" sailed
     straight through and hard-bounced forever: 4 of 296 quiz signups between
     2026-05-25 and 2026-08-18, i.e. 1.4% of all signups lost for want of a
     tld check. We SUGGEST a correction rather than reject, because a hard
     reject loses the signup just as surely. ".co" is a real tld, so it is only
     corrected for domains that provably have no .co variant (see DOMAIN_FIX). */
  var TLD_FIX = {
    con: 'com', cim: 'com', cpm: 'com', vom: 'com', xom: 'com', som: 'com',
    comm: 'com', cmo: 'com', ocm: 'com', copm: 'com', clm: 'com',
    nte: 'net', ner: 'net', bet: 'net', orgg: 'org', orh: 'org'
  };
  var DOMAIN_FIX = {
    'gmial.com': 'gmail.com', 'gmai.com': 'gmail.com', 'gnail.com': 'gmail.com',
    'gmaill.com': 'gmail.com', 'gmail.co': 'gmail.com', 'gamil.com': 'gmail.com',
    'yahooo.com': 'yahoo.com', 'yaho.com': 'yahoo.com', 'yahoo.co': 'yahoo.com',
    'hotmial.com': 'hotmail.com', 'hotmai.com': 'hotmail.com',
    'outlok.com': 'outlook.com', 'iclould.com': 'icloud.com', 'icloud.co': 'icloud.com'
  };
  function suggestEmail(email) {
    var at = email.lastIndexOf('@');
    if (at < 1) return null;
    var local = email.slice(0, at), domain = email.slice(at + 1).toLowerCase();
    if (DOMAIN_FIX[domain]) return local + '@' + DOMAIN_FIX[domain];
    var dot = domain.lastIndexOf('.');
    if (dot < 1) return null;
    var tld = domain.slice(dot + 1);
    if (TLD_FIX[tld]) return local + '@' + domain.slice(0, dot + 1) + TLD_FIX[tld];
    return null;
  }

  /* ── QUIZ DATA ──────────────────────────────────────────── */
  var Q1 = {
    q: "What's your wine world?",
    key: 'wine_style',
    opts: [
      { v: 'classic', l: 'Classic appellations',       s: 'Burgundy, Barolo, Chablis' },
      { v: 'natural', l: 'Natural & low-intervention', s: 'Small producers, living wines' },
      { v: 'both',    l: 'I want to explore both',     s: 'No allegiances, just good wine' }
    ]
  };

  var Q2 = {
    q: 'How do you usually drink?',
    key: 'drinking_occasion',
    opts: [
      { v: 'weeknight',  l: 'Weeknight with dinner',   s: 'Something honest and drinkable' },
      { v: 'occasion',   l: 'Special occasions',       s: 'Worth remembering' },
      { v: 'collection', l: 'Building a small cellar', s: 'Patience is the plan' }
    ]
  };

  var HEADS = {
    'classic-weeknight':   'For the classic wine lover\nat the dinner table.',
    'classic-occasion':    'For the classic wine lover\nwho marks the moment.',
    'classic-collection':  'For the collector\nwho knows what\'s good.',
    'natural-weeknight':   'For the natural wine drinker\nwho drinks well every night.',
    'natural-occasion':    'For the natural wine devotee\nwho celebrates properly.',
    'natural-collection':  'For the natural wine explorer\nbuilding something special.',
    'both-weeknight':      'For the curious drinker\nwho eats well and drinks better.',
    'both-occasion':       'For the one who hasn\'t picked a side\nand doesn\'t need to.',
    'both-collection':     'For the explorer\nwho wants it all.'
  };

  /* ── STATE ──────────────────────────────────────────────── */
  var answers     = {};
  var currentStep = 0;
  var overlay, card, dotsEl, inner, lastFocused;

  /* ── CSS ────────────────────────────────────────────────── */
  function injectCSS() {
    var s = document.createElement('style');
    s.textContent = [
      '#pw-overlay{',
        'position:fixed;inset:0;z-index:99999;',
        'background:rgba(32, 32, 32,0.55);backdrop-filter:blur(3px);-webkit-backdrop-filter:blur(3px);',
        'display:flex;align-items:center;justify-content:center;',
        'opacity:0;transition:opacity .32s cubic-bezier(.23,1,.32,1);',
        'font-family:"Inter",-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;',
      '}',
      '#pw-overlay.pw-on{opacity:1}',

      '#pw-card{',
        'background:#fff;width:100%;max-width:460px;',
        'position:relative;overflow:hidden;border-radius:16px;',
        'box-shadow:0 24px 60px -18px rgba(32,32,32,.34),0 8px 22px -12px rgba(32,32,32,.18);',
        'transform:translateY(8px) scale(.96);transition:transform .34s cubic-bezier(.23,1,.32,1);',
      '}',
      '#pw-overlay.pw-on #pw-card{transform:none}',

      '#pw-close{',
        'position:absolute;top:14px;right:14px;',
        'width:30px;height:30px;display:flex;align-items:center;justify-content:center;',
        'cursor:pointer;background:none;border:none;padding:0;',
        'font-size:20px;line-height:1;color:#767676;transition:color .15s;z-index:2;',
      '}',
      '#pw-close:hover{color:#333}',

      '.pw-logo{padding:24px 24px 0;display:block}',
      '.pw-logo img{height:24px;display:block}',

      '.pw-dots{display:flex;gap:6px;padding:20px 24px 0}',
      '.pw-dot{height:3px;flex:1;border-radius:999px;background:#e8e0d6;transition:background .3s}',
      '.pw-dot.on{background:#202020}',

      '.pw-inner{padding:22px 24px 28px;transition:opacity .18s ease}',
      '.pw-inner.out{opacity:0}',

      '.pw-q{font-size:21px;font-weight:500;color:#202020;line-height:1.3;margin:0 0 16px}',
      '.pw-opts{display:flex;flex-direction:column;gap:8px}',

      '.pw-opt{',
        'width:100%;text-align:left;background:#fff;',
        'border:1.5px solid #e8e0d6;border-radius:12px;padding:13px 15px;cursor:pointer;',
        'transition:border-color .15s,background .15s,transform .1s ease;',
      '}',
      '.pw-opt:hover{border-color:#202020;background:#faf9f7}',
      '.pw-opt:active{transform:scale(.99)}',
      '.pw-ol{display:block;font-size:15px;font-weight:500;color:#202020}',
      '.pw-os{display:block;font-size:13px;color:#6b6b6b;margin-top:2px}',

      '.pw-head{font-size:21px;font-weight:500;color:#202020;line-height:1.35;margin:0 0 8px;white-space:pre-line}',
      '.pw-sub{font-size:15px;color:#555;line-height:1.65;margin:0 0 18px}',

      '.pw-input{',
        'width:100%;box-sizing:border-box;',
        'border:1.5px solid #e8e0d6;border-radius:12px;padding:13px 15px;',
        'font-size:15px;font-family:inherit;color:#333;background:#fff;',
        'outline:none;transition:border-color .15s;margin-bottom:6px;display:block;',
      '}',
      '.pw-input:focus{border-color:#202020}',
      '.pw-input::placeholder{color:#767676}',
      '.pw-input.err{border-color:#c0392b}',

      '.pw-errmsg{font-size:12px;color:#c0392b;margin:0 0 10px;display:none}',
      '.pw-errmsg.on{display:block}',

      '.pw-btn{',
        'width:100%;background:#202020;color:#fff;border:none;border-radius:999px;',
        'padding:15px;font-size:15px;font-weight:600;font-family:inherit;',
        'cursor:pointer;transition:opacity .15s,transform .1s ease;margin-bottom:10px;display:block;',
      '}',
      '.pw-btn:hover{opacity:.88}',
      '.pw-btn:active{transform:scale(.99)}',
      '.pw-btn:disabled{opacity:.45;cursor:not-allowed}',

      '.pw-fine{font-size:12px;color:#6b6b6b;text-align:center;margin:0}',

      '.pw-tick{font-size:26px;display:block;margin-bottom:10px;color:#202020}',
      '.pw-shead{font-size:22px;font-weight:500;color:#202020;margin:0 0 6px}',
      '.pw-ssub{font-size:15px;color:#555;line-height:1.65;margin:0 0 18px}',

      '.pw-codebox{',
        'display:flex;align-items:center;justify-content:space-between;',
        'border:1.5px dashed #202020;border-radius:12px;padding:12px 15px;margin-bottom:18px;',
      '}',
      '.pw-code{',
        'font-family:"Inter",-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;',
        'font-size:20px;letter-spacing:.15em;color:#202020;font-weight:600;',
      '}',
      '.pw-copy{',
        'font-size:12px;font-weight:600;color:#202020;',
        'background:none;border:1px solid #202020;border-radius:999px;padding:5px 11px;',
        'cursor:pointer;font-family:inherit;transition:background .15s,color .15s;',
      '}',
      '.pw-copy:hover{background:#202020;color:#fff}',

      '.pw-shoplink{',
        'display:block;width:100%;background:#202020;color:#fff;border-radius:999px;',
        'text-decoration:none;text-align:center;padding:15px;',
        'font-size:15px;font-weight:600;font-family:inherit;',
        'box-sizing:border-box;transition:opacity .15s;',
      '}',
      '.pw-shoplink:hover{opacity:.88;color:#fff}',

      /* keyboard focus rings */
      '.pw-opt:focus-visible,.pw-btn:focus-visible,.pw-copy:focus-visible,.pw-shoplink:focus-visible,#pw-close:focus-visible{outline:2px solid #202020;outline-offset:2px}',

      '@media(max-width:520px){',
        '#pw-overlay{align-items:flex-end}',
        '#pw-card{max-width:100%;border-radius:16px 16px 0 0;transform:translateY(20px)}',
        '.pw-q,.pw-head,.pw-shead{font-size:19px}',
        /* keep tappable content clear of the floating chat launcher */
        '.pw-inner{padding-bottom:calc(92px + env(safe-area-inset-bottom,0px))}',
      '}',

      /* respect reduced-motion preference */
      '@media(prefers-reduced-motion:reduce){',
        '#pw-overlay,#pw-card,.pw-inner,.pw-dot,.pw-opt,.pw-btn{transition:none}',
        '#pw-card{transform:none}',
      '}'
    ].join('');
    document.head.appendChild(s);
  }

  /* ── BUILD ──────────────────────────────────────────────── */
  function build() {
    lastFocused = document.activeElement;
    overlay = el('div', { id: 'pw-overlay', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Find your wine style' });
    card    = el('div', { id: 'pw-card' });

    var logoWrap = el('div', { className: 'pw-logo' });
    var logoImg  = el('img', {
      src: 'https://cdn.shopify.com/s/files/1/0019/3363/9735/files/primal-wine-logo-song-customized-final-202020.svg?v=1782858277',
      alt: 'Primal Wine', height: '24'
    });
    logoWrap.appendChild(logoImg);
    card.appendChild(logoWrap);

    var closeBtn = el('button', { id: 'pw-close', type: 'button', 'aria-label': 'Close' });
    closeBtn.innerHTML = '&times;';
    closeBtn.addEventListener('click', dismiss);
    card.appendChild(closeBtn);

    dotsEl = el('div', { className: 'pw-dots' });
    card.appendChild(dotsEl);

    inner = el('div', { className: 'pw-inner' });
    card.appendChild(inner);

    overlay.appendChild(card);
    document.body.appendChild(overlay);
    setBackgroundInert(true);

    document.addEventListener('keydown', onKeydown, true);

    renderStep(0);
    raf(function () { raf(function () { overlay.classList.add('pw-on'); }); });
  }

  /* ── FOCUS MANAGEMENT ───────────────────────────────────── */
  /* The page behind the quiz leaves the accessibility tree and the Tab order while the quiz is open
     (aria-modal alone does not hide it in every screen reader). Only elements this script made inert
     are restored, so the age gate's own inert handling is left alone. */
  var madeInert = [];
  function setBackgroundInert(on) {
    if (on) {
      Array.prototype.forEach.call(document.body.children, function (n) {
        if (n === overlay || n.inert || n.tagName === 'SCRIPT') return;
        n.inert = true; madeInert.push(n);
      });
    } else {
      madeInert.forEach(function (n) { n.inert = false; });
      madeInert = [];
    }
  }

  function focusFirst() {
    var f = inner.querySelector('button, [href], input, select, textarea');
    if (f) f.focus();
  }

  function focusables() {
    var nodes = overlay.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    return Array.prototype.filter.call(nodes, function (n) {
      return !n.disabled && n.offsetParent !== null;
    });
  }

  function onKeydown(e) {
    if (e.key === 'Escape') { e.preventDefault(); dismiss(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ── STEP RENDERING ─────────────────────────────────────── */
  function renderStep(n) {
    currentStep = n;
    updateDots(n);
    if (n === 0)      renderQ(Q1);
    else if (n === 1) renderQ(Q2);
    else              renderEmail();
  }

  function updateDots(active) {
    dotsEl.innerHTML = '';
    for (var i = 0; i < 3; i++) {
      var d = el('div', { className: 'pw-dot' + (i <= active ? ' on' : '') });
      dotsEl.appendChild(d);
    }
  }

  function fade(fn) {
    inner.classList.add('out');
    setTimeout(function () { fn(); inner.classList.remove('out'); }, 180);
  }

  function renderQ(q) {
    inner.innerHTML = '';

    var qEl = el('p', { className: 'pw-q' });
    qEl.textContent = q.q;
    inner.appendChild(qEl);

    var opts = el('div', { className: 'pw-opts' });
    q.opts.forEach(function (o) {
      var btn = el('button', { type: 'button', className: 'pw-opt' });
      var label = el('span', { className: 'pw-ol' });
      label.textContent = o.l;
      var sub = el('span', { className: 'pw-os' });
      sub.textContent = o.s;
      btn.appendChild(label);
      btn.appendChild(sub);
      btn.addEventListener('click', function () {
        answers[q.key] = o.v;
        fade(function () { renderStep(currentStep + 1); });
      });
      opts.appendChild(btn);
    });
    inner.appendChild(opts);
    focusFirst();
  }

  function renderEmail() {
    var key  = answers.wine_style + '-' + answers.drinking_occasion;
    var head = HEADS[key] || 'For the wine lover who knows\nwhat they\'re looking for.';

    inner.innerHTML = '';

    var h = el('p', { className: 'pw-head' });
    h.textContent = head;
    inner.appendChild(h);

    var s = el('p', { className: 'pw-sub' });
    s.textContent = '10% off your first order, and curated picks in your inbox every week.';
    inner.appendChild(s);

    var input = el('input', { type: 'email', className: 'pw-input', placeholder: 'Your email address', autocomplete: 'email' });
    inner.appendChild(input);

    var errMsg = el('p', { className: 'pw-errmsg' });
    errMsg.textContent = 'Please enter a valid email address.';
    inner.appendChild(errMsg);

    var btn = el('button', { type: 'button', className: 'pw-btn' });
    btn.textContent = 'Claim your 10% off';
    inner.appendChild(btn);

    var fine = el('p', { className: 'pw-fine' });
    fine.textContent = 'No spam. Unsubscribe anytime.';
    inner.appendChild(fine);

    var typoOK = false;
    btn.addEventListener('click', function () {
      var email = input.value.trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || isBlocked(email)) {
        input.classList.add('err');
        errMsg.textContent = 'Please enter a valid email address.';
        errMsg.classList.add('on');
        return;
      }
      var fix = suggestEmail(email);
      if (fix && fix !== email && !typoOK) {
        input.value = fix;              /* pre-fill the fix so one more tap accepts it */
        typoOK = true;                  /* a second click sends whatever is in the box */
        input.classList.remove('err');
        errMsg.textContent = 'We corrected this to ' + fix + '. Tap again to confirm.';
        errMsg.classList.add('on');
        try { input.focus(); } catch (e) {}
        return;
      }
      input.classList.remove('err');
      errMsg.classList.remove('on');
      btn.disabled = true;
      btn.textContent = 'One moment…';

      subscribe(email, function (ok) {
        if (ok) {
          localStorage.setItem(KEY_DONE, '1');
          fade(renderSuccess);
        } else {
          btn.disabled = false;
          btn.textContent = 'Claim your 10% off';
          errMsg.textContent = 'Something went wrong, please try again.';
          errMsg.classList.add('on');
        }
      });
    });

    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') btn.click(); });
    setTimeout(function () { input.focus(); }, 60);
  }

  function renderSuccess() {
    updateDots(2);
    inner.innerHTML = '';

    var tick = el('span', { className: 'pw-tick' });
    tick.textContent = '✓';
    inner.appendChild(tick);

    var h = el('p', { className: 'pw-shead' });
    h.textContent = "You're in.";
    inner.appendChild(h);

    var s = el('p', { className: 'pw-ssub' });
    s.textContent = 'Use the code below on your first order. Your first email is on the way.';
    inner.appendChild(s);

    var box = el('div', { className: 'pw-codebox' });
    var code = el('span', { className: 'pw-code' });
    code.textContent = CODE;
    box.appendChild(code);

    var copyBtn = el('button', { type: 'button', className: 'pw-copy' });
    copyBtn.textContent = 'Copy';
    copyBtn.addEventListener('click', function () {
      navigator.clipboard.writeText(CODE).then(function () {
        copyBtn.textContent = 'Copied!';
        setTimeout(function () { copyBtn.textContent = 'Copy'; }, 2000);
      });
    });
    box.appendChild(copyBtn);
    inner.appendChild(box);

    var shop = el('a', { href: '/collections/all', className: 'pw-shoplink' });
    shop.textContent = 'Start exploring →';
    inner.appendChild(shop);
    focusFirst();
  }

  /* ── KLAVIYO SUBSCRIBE ──────────────────────────────────── */
  function subscribe(email, cb) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', 'https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY_ID, true);
    xhr.setRequestHeader('content-type', 'application/json');
    xhr.setRequestHeader('revision', '2025-10-15');
    xhr.timeout = 8000;
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) return;
      cb(xhr.status < 300 || xhr.status === 409);
    };
    xhr.ontimeout = xhr.onerror = function () { cb(false); };
    xhr.send(JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: {
                  wine_style:         answers.wine_style || '',
                  drinking_occasion:  answers.drinking_occasion || ''
                }
              }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: LIST_ID } }
        }
      }
    }));
  }

  /* ── DISMISS ────────────────────────────────────────────── */
  function dismiss() {
    document.removeEventListener('keydown', onKeydown, true);
    setBackgroundInert(false);
    overlay.classList.remove('pw-on');
    localStorage.setItem(KEY_SEEN, Date.now().toString());
    setTimeout(function () {
      if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
    }, 300);
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  /* ── TRIGGER ────────────────────────────────────────────── */
  var fired = false;
  var focusWaits = 0;
  function launch() {
    if (fired) return;
    /* Never stack on the age gate. That gate is a modal dialog that owns focus
       and marks the rest of the page inert; opening this on top of it leaves a
       screen-reader or keyboard user trapped in a wine quiz while the site is
       still saying it needs their age. Wait it out instead. */
    if (document.querySelector('#modal-popup-age-verification.active')) {
      setTimeout(launch, 800);
      return;
    }
    /* Same for any other open modal: the cart, menu and filter drawers. Opening over one
       steals focus from the drawer the visitor is using (keyboard check KB-17). */
    if (document.querySelector('sidebar-drawer.sidebar--opened, [aria-modal="true"].active')) {
      setTimeout(launch, 2000);
      return;
    }
    /* Never take focus from a visitor who is in the middle of something. This dialog moves
       focus to its first control when it opens, so opening while a filter checkbox, a form
       field or a link they tabbed to holds focus throws a keyboard or screen-reader user out
       of their task. Wait for focus to be back on the page body, and give up after 8 tries
       (about 16 seconds) so the dialog never appears long after the visitor arrived. */
    var held = document.activeElement;
    if (held && held !== document.body && held !== document.documentElement) {
      if (++focusWaits > 8) return;
      setTimeout(launch, 2000);
      return;
    }
    fired = true;
    injectCSS();
    build();
  }

  var t = setTimeout(launch, TRIGGER_MS);

  if (pgCount >= TRIGGER_PGS) {
    clearTimeout(t);
    setTimeout(launch, 1200);
  }

  /* ── HELPERS ────────────────────────────────────────────── */
  function el(tag, attrs) {
    var node = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) { node.setAttribute(k === 'className' ? 'class' : k, attrs[k]); });
    return node;
  }
  function raf(fn) { requestAnimationFrame(fn); }

})();
